<template>
  <div>{{ Array.isArray(value) ? value.length > 0 ? value.join(',') : '--' : value ? value : '--' }}</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'MyText',
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      default: ''
    },
    systemVariable: {
      type: Number,
      default: undefined
    },
    systemInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      systemItem: (state) => state.system.systemItem,
      dynamicSystem: (state) => state.system.dynamicSystem
    })
  },
  watch: {
    systemInfo: {
      handler(val) {
        if (this.systemInfo && this.systemVariable) {
          const dynamicList = this.dynamicSystem.map((item) => item.code)
          if (dynamicList.includes(this.systemVariable)) {
            this.$emit('input', val[this.systemVariable].value)
          } else {
            if (!this.value) {
              this.$emit('input', val[this.systemVariable].value)
            }
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>
